module.exports = __webpack_public_path__ + "img/youshi1@2x.82ff6e6d.png";